import { Component, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AddressTranslateMode, AddressTranslatePipe } from '@shared/pipes/address-translate.pipe';

@Component({
  selector: 'app-address-translate-cell-renderer',
  templateUrl: './address-translate-cell-renderer.component.html',
  styleUrls: ['./address-translate-cell-renderer.component.scss'],
  standalone: false
})
export class AddressTranslateCellRendererComponent implements ICellRendererAngularComp {

  addressValue: string = '';
  translatedAddress: string = '';
  addressTranslateMode: AddressTranslateMode = AddressTranslateMode.FullAddress;

  constructor(
    private addressTranslatePipe: AddressTranslatePipe,
    private cdr: ChangeDetectorRef
  ) { }

  agInit(params: ICellRendererParams): void {
    this.addressValue = params.value || '';
    this.translatedAddress = this.addressValue; // Show original initially
    this.addressTranslateMode = (params as any).addressTranslateMode;
    this.translateAddress();
  }

  refresh(params: ICellRendererParams): boolean {
    this.addressValue = params.value || '';
    this.translatedAddress = this.addressValue; // Show original initially
    this.addressTranslateMode = (params as any).addressTranslateMode;
    this.translateAddress();
    return true;
  }

  private async translateAddress(): Promise<void> {
    this.translatedAddress = await this.addressTranslatePipe.transform(this.addressValue, this.addressTranslateMode);
    this.cdr.detectChanges();
  }
}
